import { makeStyles } from '@material-ui/core/styles';


export default makeStyles(theme => ({
    dialogContent: {
        flex: "1",
        // padding: "20px 10px 10px",
        backgroundColor: "#FFFFFF",
        maxWidth: "980px",
        minWidth: "1024px"
    },
    box: {
        display: "flex",
        flexFlow: "column",
        height: "100%",
        // padding: "18px 10px 10px 20px",
        padding: '0px 0px 15px 0px'
    },
    header: {
        flex: "0 1 auto",
        display: "flex",
        padding: '15px 10px',
        alignItems: 'center',
        backgroundColor: "#0C9BB5",
        cursor: 'move',
        justifyContent: 'space-between'
    },
    content: {
        flex: "1 1 auto",
        // maxHeight: "580px",
        // overflow: "auto",
        marginBottom: "10px",
        padding: '10px 20px'
    },
    cardHeader: {
        display: 'flex',
        alignItems: 'center',
        marginBottom: '10px',
        justifyContent: 'space-between',
        borderBottom: '1px solid #F1F1F1',
        backgroundColor: "#DFEEFF",
        padding: '0 10px'
    },
    shippingLayout: {
        "& .custom-label": {
           // marginTop: '10px !important',
        }
        
    },
    textEditor: {
        "& .public-DraftEditor-content": {
            minHeight: '160px',
            maxHeight: '160px',
        }
    },
    marginTopTwenty: {
        marginTop: '25px',
    },
    cardHeaderTitle: {
        display: "flex",
        alignItems: "center"
    },
    container: {
        paddingRight: '25px'
    },
    footer: {
        flex: "0 1 40px",
        gap: '10px',
        padding: '0 20px',
        marginTop:'10px'
    },
    footerRight: {
        float: "right",
        marginRight: "-8px",
        display: 'flex',
        gap: '10px'
    },
    crossButton: {
        position: "relative",
        top: "-12px",
        right: "10px",
        cursor: "pointer",
        padding: "3px",
        zIndex: "2",
        display: "block",
        "& :hover": {
            backgroundColor: "#F4F4F4",
        }
    },
    closeIcon: {
        cursor: 'pointer',
        color: 'white',
    },
    title: {
        fontFamily: 'Lato',
        fontStyle: 'normal',
        fontWeight: 700,
        fontSize: '20px',
        lineHeight: '24px',
        color: '#FFFFFF',
        letterSpacing: '0.02em',
    },
    labelText: {
        fontFamily: 'Lato',
        fontStyle: 'normal',
        fontWeight: 600,
        fontSize: '16px',
        lineHeight: '20px',
        color: '#3C4549',
        padding: "14px 0px 5px",
    },
    valueText: {
        fontFamily: 'Lato',
        fontStyle: 'normal',
        fontWeight: 400,
        fontSize: '16px',
        lineHeight: '20px',
        color: '#3C4549',
        padding: "6px 0",
        textTransform: 'capitalize',
    },
    backBtn: {
        fontSize: '14px',
        lineHeight: '16px',
        fontWeight: 600,
        color: '#454545',
        borderRadius: '4px',
        padding: '8px 16px',
        textTransform: 'uppercase',
        border: '1px solid #454545',
        cursor: 'pointer',
    },
    changeBtn: {
        fontSize: '14px',
        lineHeight: '16px',
        fontWeight: 600,
        cursor: 'pointer',
        backgroundColor: '#454545',
        borderRadius: '4px',
        marginRight: '5px',
        padding: '8px 16px',
        textTransform: 'uppercase',
        cursor: 'pointer',
        color: '#ffffff',
        boxShadow: '0px 0px 4px rgba(0, 0, 0, 0.14), 0px 3px 4px rgba(58, 58, 68, 0.12)',
        '&:hover': {
            color: '#ffffff',
            background: '#5e5e5e',
        }
    },
    templateFooter: {
        background: '#282827',
        padding: '5px 11px',
        marginTop: '15px',
        "& p": {
            margin: 0,
            color: 'white',
            display: 'flex',
            fontSize: '13px',
            alignItems: 'center',
            justifyContent: 'center',
        }
    },
    secHeading: {
        color: '#4F4F4F',
        fontSize: '16px',
        lineHeight: '12px',
        padding: '12px 6px',
        borderBottom: '1px solid #BBBEBF',
        width: '100%',
        marginBottom: '15px',
        fontFamily: 'Lato',
        fontWeight: 600,
    },
    
    brandBox : {
        color: 'white',
        textAlign: 'center',
        minHeight: '198px',
        display: 'flex',
        flexFlow: 'column',
        margin: 'auto',
        "& img": {
            maxWidth: '125px',
            margin: 'auto',
        },
        "& h2": {
            fontSize: '16px',
            fontFamily: 'Lato',
            fontWeight: 'bold',
            color: 'white',
            width: '85%',
            margin: '20px auto',
        }
    },
    templateContainer: {
        margin: 'auto',
        "& .tempHeader": {
            background: '#454545',
            padding: '5px',
            display: 'flex',
            alignItems: 'center',
            "& img": {
                maxWidth: '120px',
                padding: '5px',
            }
        },
        "& .tempHeaderBottom": {
            background: '#EDEDED',
            textAlign: 'center',
            padding: '10px',
            fontSize: '16px',
            "& h3": {
                margin: 0,
            }
        },
        "& .tempContent": {
            padding: '15px',
            "& h1": {
                fontSize: '22px',
            },
            "& p": {
                margin: '5px 0px',
            }
        },
        "& img": {
         //   width: '100%',
        }
    },
    sectionHeading: {
        color: '#474747',
        borderBottom: '1px solid #d0d0d0',
        padding: '2px 0px 11px 0px',
        textTransform: 'capitalize',
    },
    formControl: {
        "& .MuiTypography-root": {
            fontSize: '14px',
            "& p": {
                margin: 0,
            }
        },
        "& .MuiFormControlLabel-root": {
            alignItems: 'center',
        },
        "& .MuiButtonBase-root": {
            padding: '5px 8px',
        }
    },
    selectBaseInput: {
        width: '100%',
        display: 'flex',
        boxSizing: 'border-box',
        margin: '5px 0px 5px',
        backgroundColor: 'white',
        minHeight: '35.63px',
        padding: '0px 8px 0px 0px',
        height: '35.63px',
        opacity: '0.7',
        border: '0.5px solid #777D80',
        borderRadius: '4px',



        "& .MuiInputBase-input": {
            padding: "0px 24px 0px 12px",
            minHeight: "35.63px",
            fontSize: "14px",
            color: "#4A4A4A",
            '&:focus': {
                background: 'transparent',
                borderRadius: "4px",
                outline: 0,
            },
            "&:before": {
                borderBottom: 'none !important',
            },
        },
        "& .MuiInput-underline:before": {
            borderBottom: 'none'
        },

        "& .Mui-disabled": {
            backgroundColor: "#f3f3f3",
            color: "#4A4A4A",
            minHeight: "28.63px"
        },
        "& input::-webkit-outer-spin-button": {
            appearance: "none",
            margin: 0
        },
        "& input::-webkit-inner-spin-button": {
            appearance: "none",
            margin: 0
        },
        "& input[type=number]": {
            appearance: "textfield"
        },
    },
    previewImg: {
        width: '100%',
        borderRadius: '15px',
        margin: '10px 0',
    },
    getMdn: {
        background: 'white',
        border: '1px solid #b8b8b8',
        margin: '4px',
        padding: '5px 30px',
        textTransform: 'capitalize',
    },
    previewImg: {

    },
    radioInfo: {
        "& .MuiFormGroup-root": {
            display: 'flex',
            flexDirection: 'row',
        },
        "& .MuiFormControlLabel-label": {
            fontFamily: 'Lato !important',
            fontStyle: 'normal',
            fontSize: '13px',
            fontWeight: 600,
            color: '#4b4b4b',
        },
    },
    gridHeader: {
        color: '#40403F',
        fontSize: '23px',
        fontStyle: 'normal',
        fontWeight: '600',
        lineHeight: 'normal',
        fontFamily: 'lato',
        textAlign: 'initial',
        paddingTop: '15px',
    },
    gridValue:{
        //textAlign:'center',
        display: 'flex',
        padding: '5px 0',
        gap: '15px',
        fontFamily: 'lato',
        flexWrap: 'wrap',

        "& span" : {
            color: '#40403F',
            
            fontSize: '16px',
            fontStyle: 'normal',
            fontWeight: 400,
            lineHeight: 'normal',
        },
        "& .gridStaric" : {
            color: '#F00',
            
            fontSize: '16px',
            fontStyle: 'normal',
            fontWeight: 400,
            lineHeight: 'normal',
        },
        "& .gridPartialHeader" : {
            color: '#40403F',
            
            fontSize: '16px',
            fontStyle: 'normal',
            fontWeight: 700,
            lineHeight: 'normal',
            padding: '0px 0'

        },
        "& .signature": {
            fontSize: '19px',
            lineHeight: '1',
            fontFamily: 'HomeMadeApple',
            fontWeight: '400',
            fontStyle: 'normal',
        }

        
    },
    previewPhotoMain: {
        display: 'flex',
        justifyContent: 'center',
        marginRight: '10px',
        "& .previewPhotoBorder":{
            padding:  '20px',
            border: '2px dashed',
            borderRadius: '12px',
            minWidth: '700px',
            maxWidth: '700px',
            minHeight: '300px',

        },

        "& .PreviewPhotoBorderboth": {
            padding:  '20px',
            border: '2px dashed',
            borderRadius: '12px',
            maxWidth: '450px',
            minWidth: '450px',
            minHeight: '300px',
        },
        "& .previewPhotoBg": {
            backgroundColor: '#F3F3F3',
            padding: '8px 7px;',
            borderRadius: '12px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: 'inherit',
        },
        "& .singleImageContainer": {
            maxWidth: '100%',
            borderRadius: '5px',
            objectFit: 'contain',
            maxHeight: '360px',
            minHeight: '360px',
        },
        "& .bothImageContainer": {
            maxWidth: '100%',
            maxHeight: '320px',
            minHeight: '320px',
            objectFit: 'contain',
            borderRadius: '5px',
        },
    },
    headerLogo:{
        width: '-webkit-fill-available',
        display: 'flex',
        justifyContent: 'center',
        "& img": {
            maxWidth: '300px',
        }
    },
    containerStyle: {
        padding: '20px 0'
    },
    activationTable: {
        border: '1px solid #d2d2d2',
        width: '100%',
        "& th": {
            padding: '7px',
            textAlign: 'left',
        },
        "& td": {
            padding: '7px',
            textAlign: 'left',
        },
        "& .headerRow": {
            borderBottom: '1px solid #d2d2d2',
        },
    }
}));